import isNil from 'lodash/isNil';
import { useMemo } from 'react';

import { TransactionProps } from '../types';

export interface UseFormHeightArgs {
  transaction?: TransactionProps;
  hasAction: boolean;
}

export default function useFormHeight({ transaction, hasAction }: UseFormHeightArgs): number {
  const fieldsHeightSubstract = useMemo(
    () =>
      transaction
        ? [
            !transaction.isFPS ? 65 : 0,
            // eslint-disable-next-line no-nested-ternary
            !transaction.person?.phone && !transaction.person?.name
              ? 77
              : !transaction.person?.phone || !transaction.person?.name
              ? 24
              : 0,
            isNil(transaction.sbpId) ? 53 : 0,
            !transaction.message ? 53 : 0,
            !transaction.bank ? 53 : 0,
            !hasAction ? 60 : 0,
          ].reduce((result, val) => result + val, 0)
        : 0,
    [hasAction, transaction],
  );
  return useMemo(() => (transaction ? 660 : 300) - fieldsHeightSubstract, [fieldsHeightSubstract, transaction]);
}
